/*
 * @Author: your name
 * @Date: 2021-10-19 10:27:23
 * @LastEditTime: 2023-10-31 15:10:20
 * @LastEditors: LAPTOP-JM4BAR46
 * @Description: In User Settings Edit
 * @FilePath: \newBj-admin\src\api\orderApi\internal.js
 */
import { generate } from '@/utils/request';

const config = {
  prefix: '/sord/v1/{organizationId}',
  items: [
    // 创建手工单
    { key: 'addInternalOrderByHand', url: '/order/hand-order', method: 'POST', loadingMore: 999 },
    // 编辑订单 POST /v1/{organizationId}/order/update-inner-order-info
    { key: 'editInternalOrder', url: '/order/update-inner-order-info', method: 'POST', loadingMore: 999 },
    // 复制手工单
    {
      key: 'addInternalOrderByCopy',
      url: '/order/copy-order?innerOrderNo={innerOrderNo}',
      method: 'GET',
    }, // innerOrderNo
    // 内部订单买家及收货信息
    { key: 'modifyReceiverinfo', url: '/order/modify-receiverinfo', method: 'PUT' },
    // 内部订单列表
    { key: 'getInternalPage', url: '/order/order-page', method: 'POST' },
    // 内部订单列表2
    { key: 'getInternalPage2', url: '/order/order-page', method: 'POST', loadingHide: true },
    // 详情页-物流信息-包裹号 tab页数据
    { key: 'getInternalTrackInfo', url: '/post/track?innerOrderNo={innerOrderNo}', method: 'GET', loadingHide: true },
    // 订单统计列表
    { key: 'getStatisticsPage', url: '/order/order-abnormal-page', method: 'POST' },
    // 获取 物流信息导入 页面数据
    { key: 'getStatisticsLogisticsPage', url: '/order/orderLogisticsList', method: 'POST' },
    // 物流信息导入页面 导入按钮
    { key: 'getStatisticsLogisticsListImport', url: '/order/orderLogisticsListImport', method: 'POST' },
    // 物流信息导入页面 删除按钮
    { key: 'LogisticsPageDelOrder', url: '/order/delOrderLogistics?innerOrderNo={innerOrderNo}', method: 'GET' },
    // 获取预占超时订单
    { key: 'getOrderOperationPage', url: '/order/order-operation-page', method: 'POST' },
    // 订单预占 POST /v1/order/order-preemption
    { key: 'preemptionOrder', url: '/order/order-preemption?innerOrderNo={innerOrderNo}', method: 'POST' },
    // 预占超时：预占、推送 二合一接口 POST /v1/{organizationId}/order/orderOperation/order-preempt-timeout-handle
    { key: 'preemptionOrderFusion', url: '/order/orderOperation/order-preempt-timeout-handle?innerOrderNo={innerOrderNo}', method: 'GET' },
    // 订单导出
    { key: 'getStatisticsImport', url: '/order/order-abnormal-import?exportType=COLUMN', method: 'POST' },
    // 订单导出
    { key: 'getStatisticsImport2', url: '/order/order-abnormal-import', method: 'POST', rType: 2 },
    // 订单详情订单基本信息
    { key: 'getInternalDetail', url: '/order/order-base-detail/{orderId}', method: 'GET' },
    // 订单详情订单基本信息{"orderCode": "string","orderId": 0}
    {
      key: 'getInternalDetailByIdCode',
      url: '/order/order-base-detail-by-id-code',
      method: 'POST',
    },
    // 获取订单Item列表（某订单的SKU汇总）
    {
      key: 'getInternalSkuListByOrder',
      url: '/order/order-item-page',
      method: 'POST',
    },
    //  获取订单平摊行列表（某订单的商品行列表）
    { key: 'getInternalSkuLineListByOrder', url: '/order/item-line-page', method: 'POST' },
    //  展开行：根据itemId获取平摊商品行列表（某订单的某SKU的商品行列表）

    {
      key: 'getInternalSkuLineListBySku',
      url: '/order/item-line-details/{itemId}',
      method: 'GET',
      loadingHide: true,
    },
    /** 订单审核（通过，拒绝） */
    { key: 'auditOrder', url: '/order-header/audit-order', method: 'PUT' },
    /** 订单商品行审核(通过, 拒绝) */
    { key: 'auditGoodsLineAuditOrder', url: '/order-header/goods-line-audit-order', method: 'PUT' },
    /** 订单挂起/解挂 */
    { key: 'upOrderHandUpOrder', url: '/order-header/order-hand-up', method: 'PUT' },
    /** 订单商品行挂起/解挂 */
    { key: 'upGoodsLineHandUpOrder', url: '/order-header/goods-line-hand-up', method: 'PUT' },

    /** 订单基础信息的修改 */
    { key: 'updateOrderBase', url: '/order/order-base', method: 'PUT' },

    /** 订单取消 普通订单 */
    { key: 'cancelInternalOrder', url: '/order/cancel-order', method: 'PATCH' },
    /** 订单取消 处理中订单   post /v1/{organizationId}/order/cancel-csg-order  */
    { key: 'cancelInternalProccessingOrder', url: '/order/cancel-csg-order', method: 'POST' },
    /** 订单保存 处理中订单   post /v1/{organizationId}/order/update-csg-order  */
    { key: 'updateInternalProccessingOrder', url: '/order/update-csg-order', method: 'POST' },
    /** 处理中订单 包材侧边栏   get /v1/{organizationId}/packing/getWebPackingList  */
    { key: 'getOrderPackageList', url: '/packing/getWebPackingList?innerOrderNo={innerOrderNo}', method: 'GET' },
    /** 处理中订单 包材侧边栏 保存  post /v1/{organizationId}/packing/addWebPacking  */
    { key: 'addWebPacking', url: '/packing/addWebPacking', method: 'POST' },
    /** 订单取消 SAP订单 */
    { key: 'cancelInternalSAPOrder', url: '/order/cancel-remote-sap-order', method: 'GET' },
    /** 订单解除预占 GET /v1/{organizationId}/order/order-un-preempt*/
    { key: 'unPreemptInternalOrder', url: '/order/order-un-preempt', method: 'GET' },
    /** 订单重新预占 */
    { key: 'reallocateOrder', url: '/order/order-re-preempt', method: 'GET' },
    //  指定订单进行reprocess  post /v1/{organizationId}/order/orderOperation/rePreempOutOfStock  马光浩
    { key: 'rePreempOutOfStock', url: '/order/orderOperation/rePreempOutOfStock', method: 'POST' },
    /** 取消物流 */
    { key: 'cancelInternalLogistics', url: '/order/cancel-order-logistics', method: 'GET' },
    /** 推送至SAP订单 */
    { key: 'pushToSapOrder', url: '/order/order-bigtext-push', method: 'POST' },
    /** 选择物流 */
    { key: 'modifyLogistics', url: '/order/modify-logistics', method: 'PUT' },
    /** 选择是否自提单 */
    { key: 'modifyIsPickUp', url: '/order/order-pickUp', method: 'POST' },
    /** 获取关联重发单列表 */
    { key: 'getResendList', url: '/order/resend-list?outerOrderNo={outerOrderNo}', method: 'POST' },
    /** 订单取消 O2O */
    { key: 'cancelInternalO2oOrder', url: '/order/cancel-o2o-order', method: 'PATCH' },
    /** 订单级挂起 */
    { key: 'suspendOrderByOrderId', url: '/order/suspend-order', method: 'POST' },
    /** 订单级解挂 */
    { key: 'unsuspendOrderByOrderId', url: '/order/unsuspend-order', method: 'POST' },
    { key: 'unsuspendOrderByInner', url: '/order/unsuspend-order-by-inner', method: 'POST' },
    /** 商品行级挂起/解挂 */
    { key: 'suspendOrderByItemLine', url: '/order/itemLine-suspend-order', method: 'POST' },
    /** 商品行级预占/解占 */
    { key: 'preemptionOrderByItemLine', url: '/order/re-preemption', method: 'POST' },

    /** 订单级-确认收货 普通订单 */
    { key: 'confirmReceiptByOrderId', url: '/order/confirm-receipt/', method: 'PATCH' },

    /** 订单级-确认收货 o2o */
    { key: 'o2oConfirmReceiptByOrderId', url: '/order/o2o-confirm-receipt', method: 'POST' },

    /** 商品行级-确认收货 */
    { key: 'confirmReceiptByItemLine', url: '/order/item-confirm-receipt', method: 'POST' },

    // 内部缺货订单列表
    { key: 'getInternalStockoutPage', url: '/order/stockout-page', method: 'POST' },
    /** 缺货管理导出  */
    { key: 'exportStockout', url: '/order/stock-out-export', method: 'GET' },
    { key: 'exportStockout2', url: '/order/stock-out-export', method: 'GET', rType: 2 },
    // 内部缺货订单列表
    { key: 'ETApush', url: '/order/getSkuDeliveryTime', method: 'POST' },

    /** 缺货统计列表 */
    { key: 'getOrderStatsStockout', url: '/order/stats/stockout', method: 'POST' },
    /** 根据外部订单号获取收货加密信息 */
    { key: 'getEncryptReceiverInfo', url: '/order/encrypt-receiver-info', method: 'GET' },
    /** 订单操作日志列表  */
    { key: 'getLogPage', url: '/operate-logs', method: 'GET' },
    /** 内部订单导出  */
    { key: 'pageExport', url: '/order/order-page-import?exportType=COLUMN', method: 'POST' },
    /** 内部订单物流信息导出  */
    { key: 'logisticsExport', url: '/order/order-logis-import?exportType=COLUMN', method: 'POST' },

    // 手工下载授权渠道订单
    { key: 'platformOrderSync', url: '/order/platformOrderSync', method: 'POST' },

    /** 订单推送列表  */
    { key: 'getOrderSapPage', url: '/orderSap/order-sap-page', method: 'POST' },
    { key: 'sendOrderToSap', url: '/orderSap/send-order-to-sap', method: 'POST' },

    // 订单标记为异常单
    { key: 'orderException', url: '/order/order-exception', method: 'POST' },
    // 修改为正常单
    { key: 'orderNormal', url: '/order/normal-order/{innerOrderNo}', method: 'GET' },
    // 删除审核销售单es数据
    { key: 'deleteEsAudit', url: '/order/es-audit-delete', method: 'DELETE' },
    // 二审自动刷新ES
    { key: 'autoSecondAuditOrderRefreshES', url: '/order/order/autoSecondAudit/refreshES', method: 'GET'},
    // 更新审核订单
    { key: 'updateAuditOrder', url: '/order/update-audit-order', method: 'POST'},

    // 邮费对比 列表  post /v1/{organizationId}/invoiceInfo/searchInvoices
    { key: 'getOrderPostageList', url: '/invoiceInfo/searchInvoices', method: 'POST' },
    // 邮费对比 列表删除  post /v1/{organizationId}/invoiceInfo/delete
    { key: 'delOrderPostageList', url: '/invoiceInfo/delete', method: 'POST' },
    // 邮费对比 导入数据  post /v1/{organizationId}/invoiceInfo/saveInvoice
    { key: 'addOrderPostageList', url: '/invoiceInfo/saveInvoice', method: 'POST' },
    // 邮费对比 列表  post /v1/{organizationId}/invoiceInfo/invoiceList
    { key: 'getOrderPostageDetail', url: '/invoiceInfo/invoiceList', method: 'POST' },
    // 邮费对比 不匹配列表  post /v1/{organizationId}/invoiceInfo/unmatchedInvoices
    { key: 'getPostageDetailUNMatch', url: '/invoiceInfo/unmatchedInvoices', method: 'POST' },
    // 邮费对比 匹配列表  post /v1/{organizationId}/invoiceInfo/matchInvoices
    { key: 'getPostageDetailMatch', url: '/invoiceInfo/matchInvoices', method: 'POST' },
    // 邮费对比 详情页  get /v1/{organizationId}/invoiceInfo/{invoiceId}/detail
    { key: 'getPostageDetail', url: '/invoiceInfo/{invoiceId}/detail', method: 'GET' },
    // 邮费对比 不匹配列表导出  post /v1/{organizationId}/invoiceInfo/unmatchedInvoicesExport
    { key: 'unmatchedPostageExport', url: '/invoiceInfo/unmatchedInvoicesExport', method: 'POST' },
    // 邮费对比 匹配列表导出  post /v1/{organizationId}/invoiceInfo/matchedInvoicesExport
    { key: 'matchedPostageExport', url: '/invoiceInfo/matchedInvoicesExport', method: 'POST' },
    // 获取订单信息
    { key: 'getDetailByInnerNo', url: '/order/detail-by-inner-no?no={no}', method: 'GET'},

    { key: 'updatePickUpTime', url: '/order/updatePickUpTime', method: 'POST'},
    //  订单运输信息修改
    { key: 'modifyShippingInfo', url: '/order/modify-shipping-info', method: 'PUT'},
    //  修改CSG手动订单物流信息
    { key: 'updateOrderLogisticsCsg', url: '/order/update/order/logistics', method: 'PUT', errorHide: true },
    //  修改CUSTOMER MANUAL手动订单物流信息
    { key: 'updateCustomerManualOrderLogistics', url: '/order/update/customer-manual/order/logistics', method: 'PUT'},
    //  一键改为CSG Manual    GET /v1/{organizationId}/order/changeOrderStatusToManual  马光浩
    { key: 'changeOrderStatusToManual', url: '/order/changeOrderStatusToManual', method: 'GET'},
    // 查询订单SAP状态 GET /v1/{organizationId}/order/getOrderSapStatus  ==> 马光浩
    { key: 'getOrderSapStatus', url: '/order/getOrderSapStatus', method: 'GET' },
    // 待手动取消列表（旧）
    { key: 'getInternalPageHUNT', url: '/order/order-page-logis-cancel', method: 'POST' },
    // 待手动取消列表（新）   post /v1/{organizationId}/order/logisticsCancelPage
    { key: 'getInternalPageHUNTNew', url: '/order/logisticsCancelPage', method: 'POST' },
    // 待手动取消列表 操作 ： 物流取消按钮   post /v1/{organizationId}/order/logisticsCancelConfirm
    { key: 'cancelPageHUNTButton', url: '/order/logisticsCancelConfirm', method: 'POST' },
    // 内部订单发邮件
    { key: 'orderSendEmail', url: '/order/send-email', method: 'POST' },
    // 内部订单完结
    { key: 'innerOrderOver', url: '/order/mark-finish', method: 'POST' },

    // 等待发货==>修改label和物流   post /v1/{organizationId}/order/updateLabelAndLogistics
    { key: 'waitingUpdateLabel', url: '/order/updateLabelAndLogistics', method: 'POST', errorHide: true },
    // 等待发货==>填写修改报价金额   post /v1/{organizationId}/order/updateQuote
    { key: 'waitingUpdatePrice', url: '/order/updateQuote', method: 'POST' },
    // 等待发货==>确认报价   post /v1/{organizationId}/order/confirmQuote
    { key: 'waitingConfirmPrice', url: '/order/confirmQuote', method: 'POST' },
    // 等待发货==>修改运输方式   post /v1/{organizationId}/order/updateShippingMethod
    { key: 'waitingUpdateShipping', url: '/order/updateShippingMethod', method: 'POST' },
    // 等待发货==>修改 长、宽、高、重   post /v1/{organizationId}/order/updatePackageSize
    { key: 'waitingUpdateSize', url: '/order/updatePackageSize', method: 'POST' },

    // 订单详情页==>包材tab页   post post /v1/{organizationId}/order/getOrderPackageCount
    { key: 'getOrderPackageCountList', url: '/order/getOrderPackageCount', method: 'POST' },
    // 内部订单详情页==>订单异常原因   post /v1/{organizationId}/order/queryOrderExceptionReason
    { key: 'getOrderErrorReason', url: '/order/queryOrderExceptionReason', method: 'POST' },
    // 内部订单详情页==>处理异常订单   post /v1/{organizationId}/order/handleOrderException
    { key: 'changeOrderErrorType', url: '/order/handleOrderException', method: 'POST' },
    // 内部订单详情页==>修改收货人信息（新接口）   post /v1/{organizationId}/order/updateReceiverInfo
    { key: 'updateBuyerInfo', url: '/order/updateReceiverInfo', method: 'POST' },
    // 内部订单详情页==>获取订单label   get /v1/{organizationId}/order/getOrderLabel
    { key: 'getOrderLabel', url: '/order/getOrderLabel', method: 'GET' },

    // 物流下单页 ==> 获取顶部 订单下拉列表   get /v1/{organizationId}/order/getOrderNoList
    { key: 'getOrderNoList', url: '/order/getOrderNoList', method: 'POST' },
    // 物流下单页 ==> 手动询价   post /v1/{organizationId}/order/manualRating
    { key: 'getManualSearchPrice', url: '/order/manualRating', method: 'POST' },
    // 物流下单页 ==> 自动询价   post /v1/{organizationId}/order/manualRating
    { key: 'getAutoSearchPrice', url: '/order/autoRating', method: 'POST' },
    // 物流下单页 ==> 下单   post /v1/{organizationId}/order/orderManualLogisticsCreate
    { key: 'createManualOrder', url: '/order/orderManualLogisticsCreate', method: 'POST' },
    // 波次列表 ==> 下载  post /v1/{organizationId}/order/printOrder    何雪松
    { key: 'downPrintOrder', url: '/order/printOrder', method: 'POST' },
  ],
};

export default {
  ...generate(config),
};
